import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import { useEffect } from "react";
import "moment/locale/en-gb";
import moment from "moment";
import { datePickerAppDate, MISReportDateFormat } from "../../../constants/constants";
import PropTypes from 'prop-types';
import { getValue } from "@mui/system";

export default function DatePickerComponent({
  defaultValue=null,
  onChange,
  isFutureDisabled,
  ...props
}) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [cleared, setCleared] = useState(false);
  useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [cleared]);

  const handleDateChange = (date) => {
    // debugger//-----
    const chkdate = moment(date, datePickerAppDate);

    if (!chkdate.isValid()) {

      setSelectedDate(null);
      onChange(null);
      return;
    }
    const minDate = props.minDate  ? moment(props.minDate) : null;
    if (minDate && chkdate.isBefore(minDate, "day")) {
      const dt = moment().subtract(moment().diff(minDate,'days'),'days')
      setSelectedDate(dt);
      onChange(dt.format(datePickerAppDate));
      return;
    }
    const maxDate = props.maxDate ? moment(props.maxDate) : null;
    if (maxDate && chkdate.isAfter(maxDate, "day")) {
      const dt = moment().subtract(moment().diff(maxDate,'days'),'days')
      setSelectedDate(dt);
      onChange(dt.format(datePickerAppDate));
      return;
    }
    const now = moment();
    if (isFutureDisabled === true ? true : false) {
      if (chkdate.isAfter(now, "day")) {
        console.log(selectedDate)
        setSelectedDate(now);
        onChange(now.format(datePickerAppDate));
        return;
      }
    }
    setSelectedDate(date);
    //debugger;
    console.log(date);
    date = date.format(datePickerAppDate);
    onChange(date);
  };

  useEffect(() => {
    console.log(defaultValue);
    // debugger;//------
    var date = null;
    if (defaultValue) {
      console.log(
        moment(defaultValue, MISReportDateFormat, true).isValid(),
        moment(defaultValue, datePickerAppDate, true).isValid()
      );
      
      date = moment(defaultValue, datePickerAppDate, true).isValid()
        ? moment(defaultValue, datePickerAppDate, true)
        : moment(defaultValue, MISReportDateFormat, true);
    }
    console.log(date);
    onChange(date);
  }, []);
  useEffect(() => {
    //debugger;
    if (props.resetSelectedDate) {
      const date = moment(defaultValue);
      setSelectedDate(date);
      onChange(date.format(datePickerAppDate));
      props.setResetSelectedDate(false);
    }
  }, [props.resetSelectedDate, defaultValue, onChange, props.setResetSelectedDate]);
useEffect(()=>{
  console.log(
    props.resetSelectedDate
      ? moment(defaultValue)
      : selectedDate === null
      ? moment(defaultValue)
      : selectedDate
  );
  // debugger;
},[defaultValue, props.resetSelectedDate, selectedDate]);
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
      <DemoContainer
        sx={{
          width: props.width,
          flexDirection: "column!important",
          "&.MuiStack-root": { paddingTop: "0", overflow: "visible" },
        }}
        components={["DatePicker"]}
      >
        <DatePicker
          className="custom-dates"
          minDate={props.minDate ? moment(props.minDate) : null}
          maxDate={props.maxDate ? moment(props.maxDate) : null}
          renderInput={(params) => (
            <TextField
              {...params}
            />
          )}
          defaultValue={new Date(defaultValue)}
          slotProps={{
            textField: { size: "small" },
            field: {clearable: (props.clearable ? props.clearable : false), onClear: () => setCleared(true)},
          }}
          disableFuture={isFutureDisabled===true?true:false}
          label={props.message}
          value={(props.resetSelectedDate)?  moment(defaultValue) : ( selectedDate === null ? moment(defaultValue) : selectedDate)}
          onChange={handleDateChange}
          format={datePickerAppDate}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}


DatePickerComponent.propTypes = {
  defaultValue: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
};